import { tw } from 'utils/classnames'
import type { AidaChatPresentation } from './chat-presentation'

const detachedPresentation = (presentation: AidaChatPresentation) =>
  presentation === 'dock' || presentation === 'float'

export const threadScrollShadowClass = 'min-h-0 w-full flex-1'

const fullscreenColumnClass = 'mx-auto w-full max-w-chat'
const detachedThreadPadding = 'px-3 pb-4 pt-2'
const detachedComposerPadding = 'px-3 pb-4'
const fullscreenThreadPaddingDesktop = 'lg:px-10 lg:pb-8 lg:pt-3'
const fullscreenComposerPaddingDesktop = 'lg:px-10 lg:pb-8'

export function threadScrollerClass(presentation: AidaChatPresentation) {
  return tw(
    'h-full overflow-y-auto overflow-x-clip scroller-xs',
    presentation === 'fullscreen'
      ? tw(detachedThreadPadding, fullscreenThreadPaddingDesktop)
      : detachedThreadPadding,
  )
}

export function threadContentClass(presentation: AidaChatPresentation) {
  return presentation === 'fullscreen' ? fullscreenColumnClass : undefined
}

export function composerShellClass(presentation: AidaChatPresentation) {
  return tw(
    'w-full shrink-0 bg-theme_semantic_surface_primary-background-elevated',
    presentation === 'fullscreen'
      ? tw(detachedComposerPadding, fullscreenComposerPaddingDesktop)
      : detachedComposerPadding,
  )
}

export function composerContentClass(presentation: AidaChatPresentation) {
  return tw('flex flex-col gap-2', presentation === 'fullscreen' && fullscreenColumnClass)
}

export function isDetachedChatPresentation(presentation: AidaChatPresentation) {
  return detachedPresentation(presentation)
}

export function includesChatHistory(presentation: AidaChatPresentation) {
  return presentation === 'fullscreen'
}
